/**
 * Alaska
 * Store: Modal
 * @version 2.0 (HTML only)
 */

document.addEventListener("alpine:init", () => {
    Alpine.store("HtmlModal", {
        // ---- state ---- //
        visible: false,
        title: "Modal",
        icon: null,
        endpoint: "/alaska/public/",
        callback: null,

        html: "",
        root_el: null,
        loading: false,

        payload: null,

        mount(el) {
            this.root_el = el;
        },

        async open_html(config = {}) {
            Scroll.disable();

            this.title = config.title || "Modal";
            this.icon = config.icon || null;
            this.callback = typeof config.callback === "function" ? config.callback : null;

            if (config.payload) {
                this.payload = config.payload;
            }

            this.visible = true;

            // inject after frame is visible so element exists
            queueMicrotask(() => {
                this.render_html(config.html || "");
            });
        },


        async load_html(config = {}) {
            this.loading = true;
            Loading.show();

            try {
                let html = "";
                let title = config.title || null;
                let icon = config.icon || null;

                if (config.url) {
                    // Direct endpoint returning raw HTML
                    const method = (config.method || "GET").toUpperCase();
                    const opts = {method};
                    if (method === "POST") {
                        opts.headers = {"Content-Type": "application/json"};
                        opts.body = JSON.stringify(config.data || {});
                    }
                    const res = await fetch(config.url, opts);

                    if (!res.ok) {
                        throw new Error(`HTTP ${res.status}`);
                    }

                    html = await res.text();
                } else {

                    console.log({
                        method: "POST",
                        headers: {"Content-Type": "application/json"},
                        body: JSON.stringify({
                            controller: config.controller,
                            action: config.action,
                            data: config.data || {},
                            return: "html"
                        }),
                    });

                    // API returning JSON that includes html
                    const res = await fetch(this.endpoint, {
                        method: "POST",
                        headers: {"Content-Type": "application/json"},
                        body: JSON.stringify({
                            controller: config.controller,
                            action: config.action,
                            data: config.data || {},
                            return: "html"
                        }),
                    });
                    const json = await res.json();
                    if (json.type !== "success") throw new Error(json.message);
                    html = json.html || "";
                    title = title ?? json.title ?? "Modal";
                    icon = icon ?? json.icon ?? null;
                }

                await this.open_html({
                    title,
                    icon,
                    html,
                    payload: config.payload || null,
                    callback: config.callback
                });

            } catch (e) {
                console.error("Modal HTML load failed:", e);
            } finally {
                this.loading = false;
                Loading.hide();
            }
        },

        render_html(html_string) {
            this.html = html_string || "";
            if (!this.root_el) return;

            // Replace content
            this.root_el.innerHTML = this.html;

            try {
                Alpine.initTree(this.root_el);
            } catch (e) {
                console.warn("Alpine.initTree failed:", e);
            }

            // Execute inline <script> tags
            const scripts = this.root_el.querySelectorAll("script:not([src])");
            scripts.forEach((s) => {
                try {
                    new Function(s.textContent)();
                } catch (e) {
                    console.warn("Inline script execution failed:", e);
                }
            });
        },

        // ---- Allow HTML to finish with a payload ---- //
        finish(payload) {
            try {
                if (this.callback) { this.callback(payload); }
            } finally {
                this.close();
            }
        },

        // ---- Close and reset ---- //
        close() {
            Scroll.enable();
            this.visible = false;

            // Let the leave animation run
            setTimeout(() => {
                this.title = "";
                this.icon = null;
                this.payload = null;
                this.callback = null;
                this.html = "";
                if (this.root_el) this.root_el.innerHTML = "";
            }, 300);
        }
    });
});